// 订阅信息
export const orderType = {
    0: '试用版',
    1: ' 订阅版',
    2: '空间扩容',
    3: ' 订阅版+扩容',// 对应订阅+扩容，此处不需要展示扩容
}

// 套餐订阅
export const packageOrderType = {
    0: () => '试用版',
    1: (count, _) => {
        return `订阅版 * ${count}`
    },
    2: (_, count) => {
        return `空间扩容 * ${count}`
    },
    3: (packageCount, spaceCount) => {
        return `订阅版 * ${packageCount} + 扩容 * ${spaceCount}`
    }
}

export const validityPeriod = {
    0: '天',
    1: ' 月',
    2: '年'
}

export const orderStatus = {
    0: '待处理',
    1: '处理中',
    2: '已完成',
    3: '取消',
    4: '退款'
}

export const userCenterType = {
    0: require('@/assets/img/freeOrder.png'),
    1: require('@/assets/img/vipOrder.png'),
}